export const SECRET = 'VeRTODBUD8dp4LvZOtNt6troPXWln2A5BKeHgll6'
